import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse } from '@/types/site';
import { useMutation } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

interface ChangePasswordRequest {
  currentPassword?: string;
  newPassword: string;
}

interface ChangePasswordResponse {
  message: string;
}

export const useChangePassword = ({ userId }: { userId: string }) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.users.changePassword],
    mutationFn: async (
      data: ChangePasswordRequest
    ): Promise<ChangePasswordResponse> => {
      const response = await XHRAuthorizedClient.put<
        ApiResponse<ChangePasswordResponse>
      >(ENDPOINTS.users.changePassword(userId), data);
      return response.data.data;
    },
    onError: (error) => {
      console.error('비밀번호 변경 오류:', error);
    },
  });
};
